import { Box, styled } from '@material-ui/core';

const AppFormFields = styled(Box)(({ theme }) => ({
    '& > *:not(:last-child)': {
        marginBottom: theme.spacing(2),
    },
}));

export default AppFormFields;